import ReactValidator from "legacy/ReactValidator.es6"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import PropTypes from "prop-types"
import React from "react"

class SafeHarbor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      brewerError: "",
    }
    this.validator = new ReactValidator()
    this.callNext = this.callNext.bind(this)
    this.checkSafeHarbor = this.checkSafeHarbor.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const {
      state: { firstName, lastName, fullName },
      setGlobalState,
      setHeader,
    } = this.props

    setHeader("Safe Harbor Membership")

    if (!firstName && !lastName && fullName) {
      const components = fullName.split(" ")

      const firstNameFromFullName = components.shift()
      const lastNameFromFullName = components.join(" ")

      setGlobalState({
        firstName: firstNameFromFullName,
        lastName: lastNameFromFullName,
      })
    }
  }

  handleChange(event) {
    this.props.setGlobalState({ [event.target.name]: event.target.value })
  }

  callNext() {
    this.validator.displayErrors()
    this.setState({ validInputs: this.validator.allValid() })
    if (this.validator.allValid() === true) {
      this.setState({ processing: true })
      this.setState({ brewerError: "" })
      this.checkSafeHarbor()
    }
  }

  checkSafeHarbor() {
    const {
      state: { useDockwaPlusPricing, brewerMemberID, firstName, lastName },
    } = this.props

    const params = {
      brewer_id: brewerMemberID,
      first_name: firstName,
      last_name: lastName,
    }

    $.post(
      process.env.API_BASE_URL + "/api/1.0/validate/brewer",
      params,
      (data) => {
        const stateObject = {
          verifiedBrewer: true,
        }

        if (!useDockwaPlusPricing) {
          stateObject.promoCode = data
        }

        this.props.setGlobalState(stateObject, () => {
          this.props.routeTo("next")
        })
      }
    ).fail((data) => {
      this.setState({ brewerError: data.responseJSON.error, processing: false })
    })
  }

  render() {
    const {
      state: { brewerMemberID, firstName, lastName },
    } = this.props
    const { brewerError, processing } = this.state

    return (
      <div id="safeHarborMembership">
        <div className="flex-group-2">
          <div className="form-group">
            <label htmlFor="membershipId">Safe Harbor Membership ID</label>
            <input
              autoFocus
              className="form-control"
              id="membershipId"
              name="brewerMemberID"
              value={brewerMemberID || ""}
              onChange={this.handleChange}
            />
            {this.validator.message(
              "memberID",
              brewerMemberID,
              "required|number"
            )}
          </div>
        </div>
        <div className="flex-group-2">
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              className="form-control"
              id="firstName"
              name="firstName"
              value={firstName || ""}
              onChange={this.handleChange}
            />
            {this.validator.message("firstName", firstName, "required")}
          </div>
        </div>
        <div className="flex-group-2">
          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              className="form-control"
              id="lastName"
              name="lastName"
              value={lastName || ""}
              onChange={this.handleChange}
            />
            {this.validator.message("lastName", lastName, "required")}
          </div>
        </div>
        {this.validator.customMessage(brewerError, "-mt-1.5 mb-2.5")}
        <NextButton
          id="safeHarborContinueButton"
          btnClass="btn-primary"
          processing={processing}
          click={this.callNext}
          icon=""
          text="Add Membership"
          processingText="Verifying..."
        />
      </div>
    )
  }
}

SafeHarbor.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  state: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    fullName: PropTypes.string,
    brewerMemberID: PropTypes.string,
    useDockwaPlusPricing: PropTypes.bool,
  }).isRequired,
}

export default SafeHarbor
